import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
    selector: 'app-routeaccomplishsuperv',
    templateUrl: './routeaccomplishsuperv.component.html',
    styleUrls: ['./routeaccomplishsuperv.component.css']
})
export class RouteaccomplishsupervComponent extends BaseCrudComponent {

    translations: any;
    header: any;
    momentjs: any = moment;
    curr_date: any;
    today: any;
    dstart: any;
    dend: any;
    zones: any;
    detail1: any;
    detail2: any;
    totals1: any;
    totals2: any;


    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
    ) {
        super(srv, modalService, storage, router);
        this.read_url = 'ReportRouteGoalSupervisor/Post';
        this.header = {};
        this.zones = [];
        this.detail1 = [];
        this.detail2 = [];
        this.totals1 = {};
        this.totals2 = {};
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
            });

        this.getZonesData().subscribe(x => {
            if (x != false) {
                this.zones = x;
            }
        });
    }

    clearData() {
        this.header = {};
        this.detail1 = [];
        this.detail2 = [];
        this.totals1 = {};
        this.totals2 = {};
    }

    public getList() {
        var qst = this.read_url;
        var obj: any;
        //this.f_datefrom = '2020-10-01';
        this.clearData();

        obj = {
            Zone: null,
            Date: this.f_datefrom
        }
        console.log( this.f_datefrom);

        if ((this.f_custom1 != null) && (this.f_custom1 != 'null')) {
            obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
            this.loadingList = false;

            if (x.status) {
                var rs = x.data;
                this.header = rs.header;
                this.detail1 = rs.detail1;
                this.detail2 = rs.detail2;

                this.totals1 = rs.totalSection1;
                this.totals2 = rs.totalSection2;

                if (Array.isArray(this.detail2) && (this.detail2.length > 0)) {
                    this.detail2.forEach(d => {
                        d.semaforo_sales = this.getColor(d.goalSalesPercent);
                        d.semaforo_collect = this.getColor(d.goalCollectPercent);
                    });
                }
            }
        });
    }

    getColor(par: any) {
        var r: any;
        par = par.replace(' %', '');
        par = parseFloat(par.replace(/,/g, ''));
        r = {};

        if (par <= 80) {
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if (par > 95) {
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else {
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getZonesData() {
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
            mergeMap(data => {
                let mydata: any = { status: false, data: [], message: '' };
                mydata = data;
                //console.log(data);

                if (mydata.status) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => { return of(false) })
        );
    }

    getPdfReportHeader() {
        var obj = [];

        obj.push([{ content: 'REPORTE CUMPLIMIENTO CON OBJETIVOS DEL DIA (SUPERVISOR)', colSpan: 4, styles: { fontStyle: 'bold', halign: 'center' } }]);
        obj.push([
            { content: 'Supervisor: ' + this.header['supervisor'], colSpan: 2 },
            { content: 'Fecha de Gestión: ' + this.f_datefrom, colSpan: 2 }
        ]);
        obj.push([
            { content: 'Jefe Ventas: ' + this.header['jefe'], colSpan: 2 },
            { content: 'Fecha de Emisión: ' + this.curr_date, colSpan: 2 }
            // { content: '', colSpan: 2 }
        ]);

        return obj;
    }

    exportReport() {
        var doc = new jsPDF('l', 'pt', 'a4');
        autoTable(doc, { body: this.getPdfReportHeader(), theme: 'grid' });

        let header = [];
        let footer = [];
        let x = [];

        //Section 1
        header = [];
        header.push([{ content: 'ACTIVIDADES', colSpan: 17, styles: { fontStyle: 'bold', halign: 'center', fontSize: 10 } }]);
        // header.push(['ZONA', 'VENDEDORES', 'T. VISITA', 'T. INACTIVO', 'CLIE PLANIFICADOS EN RUTA', 'CLIE CON GESTION EN RUTA (ER)', '% COBERTURA RUTA', 'CLIE CON GESTION FUERA DE RUTA (FR)', '% CLIE FR / CLIE PLAN ER', 'CLIE TOTAL ER + FR', 'TOT CLIE VISITADOS RUTA + FUERA RUTA', '% COBERTURA TOTAL', 'CLIE CON VENTA', '% EFEC VENTA', 'CLIE CON OBJ COBRO', 'CLIE CON COBRO', '% EFEC COBR']);
        // header.push(['ZONA', 'VENDEDORES', 'T. VISITA', 'T. INACTIVO', 'CLIE PLANIFICADOS EN RUTA', 'CLIE CON GESTION EN RUTA (ER)', '% COBERTURA RUTA', 'CLIE CON GESTION FUERA DE RUTA (FR)', 'TOT CLIE PLANIFICADOS ER + FR', 'TOT CLIE CON GESTION ER + FR', '% COBERTURA TOTAL DEL DIA', 'CLIE CON VENTA EN EL DIA', '% EFEC VENTA', 'CLIE CON OBJ COBRO', 'CLIE CON COBRO', '% EFEC COBR']);
        header.push(['ZONA', 'VENDEDORES', 'T. VISITA', 'T. INACTIVO', 'CLIE PLANIFICADOS EN RUTA', 'CLIE CON GESTION EN RUTA (ER)', '% COBERTURA RUTA', 'CLIE CON GESTION FUERA DE RUTA (FR)', 'TOT CLIE PLANIFICADOS ER + FR', 'TOT CLIE CON GESTION ER + FR', '% COBERTURA TOTAL DEL DIA', 'CLIE CON VENTA EN EL DIA', '% EFEC VENTA',  'CLIE CON COBRO']);
        x = [];
        this.detail1.forEach(i => {
            x.push([
                i.zone,
                //i.seller,
                i.nombreAgente,
                i.visit,
                i.inactive,
                i.plannedClientsInRoute,
                i.visitedClientsInRoute,
                i.coverageRoute,
                i.visitedClientsOutRoute,
                // i.cliFRCliPlanER,
                i.cliTotalERFR,
                i.cliVisitInOutRoute,
                i.totalCoverage,
                i.clientWithSales,
                i.effectiveSale,
                // i.clientWithCollectGoal,
                i.clientWithCollect,
                // i.effectiveCollect
            ]);
        });

        footer = [];
        footer.push([
            {content:'', colSpan:2},
            {content: this.totals1.visitTime, styles:{halign:'center'}},
            {content: this.totals1.inactiveTime, styles:{halign:'center'}},
            {content: this.totals1.plannedClientesInRoute, styles:{halign:'center'}},
            {content: this.totals1.managedClientesInRoute, styles:{halign:'center'}},
            {content: this.totals1.routeCoverage, styles:{halign:'center'}},
            {content: this.totals1.managedClientesOutRoute, styles:{halign:'center'}},
            {content: this.totals1.plannedClientesERFR, styles:{halign:'center'}},
            {content: this.totals1.managedClientesERFR, styles:{halign:'center'}},
            {content: this.totals1.coverageDay, styles:{halign:'center'}},
            {content: this.totals1.salesClientInDay, styles:{halign:'center'}},
            {content: this.totals1.salesEffective, styles:{halign:'center'}},
            // {content: this.totals1.goalCollectClient, styles:{halign:'center'}},
            {content: this.totals1.collectClient, styles:{halign:'center'}},
            // {content: this.totals1.collectEffective, styles:{halign:'center'}}
        ]);
        autoTable(doc, { head: header, body: x, foot: footer, headStyles: { fontSize: 7, fillColor: '#3e5569', halign: 'center' }, bodyStyles: { fontSize: 7, halign: 'center' }, footStyles: { fontSize: 7, fillColor: '#e9ecef', textColor: '#000', halign: 'right' } });

        //Section 2
        header = [];
        // header.push(['ZONA', 'VENDEDORES', '$ COTIZACIÓN', '$ PEDIDOS DÍA', '$ OBJ. VTA DÍA', '% CUMP', ' ', '$ COBRO DÍA', '$ OBJ. COBRO DÍA', '% CUMP', ' ']);
        // header.push(['ZONA', 'VENDEDORES', '$ COTIZACIÓN', '$ PEDIDOS DÍA', '$ OBJ. VTA DÍA', '% CUMP', ' ', '$ COBRO DÍA', '$ OBJ. COBRO DÍA']);
        header.push(['ZONA', 'VENDEDORES', '$ COTIZACIÓN', '$ PEDIDOS DÍA', '$ OBJ. VTA DÍA', '% CUMP', ' ', '$ COBRO DÍA']);
        x = [];
        this.detail2.forEach(i => {
            x.push([
                i.zone,
                //i.seller,
                i.nombreAgente,
                { content: '$' + i.quotation, styles: { halign: 'right' } },
                { content: '$' + i.dailySales, styles: { halign: 'right' } },
                { content: '$' + i.dailyGoalSales, styles: { halign: 'right' } },
                i.goalSalesPercent,
                { content: '', styles: { fillColor: i.semaforo_sales.color, cellWidth: 15 } },
                { content: '$' + i.dailyCollect, styles: { halign: 'right' } },
                // { content: '$' + i.dailyGoalCollect, styles: { halign: 'right' } }
                // i.goalCollectPercent,
                // { content: '', styles: { fillColor: i.semaforo_collect.color, cellWidth: 15 } }
            ]);
        });

        footer = [];
        footer.push([
            {content:'', colSpan:2},
            {content: '$' + this.totals2.quotation, styles:{halign:'right'}},
            {content: '$' + this.totals2.orderDay, styles:{halign:'right'}},
            {content: '$' + this.totals2.salesGoalDay, styles:{halign:'right'}},
            {content: this.totals2.goal, styles:{halign:'center'}},
            '',
            {content: '$' + this.totals2.collectDay, styles:{halign:'right'}},
            {content: '$' + this.totals2.goalCollectDay, styles:{halign:'right'}}
        ]);
        autoTable(doc, { head: header, body: x, foot: footer, headStyles: { fontSize: 7, halign: 'center' }, bodyStyles: { fontSize: 7, halign: 'center' }, footStyles: { fontSize: 7, fillColor: '#e9ecef', textColor: '#000', halign: 'right' } });

        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('cumplimiento_ruta_supervisor_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc: any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
